<template>
    <div>
        <div class="title-box">
            工厂信息管理
        </div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-form-item>
                <el-input v-model="queryParams.factoryName" placeholder="工厂名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="info" @click="onReset">重置</el-button>
            </el-form-item>
            <!-- 添加按钮 -->
            <span style="position:relative;float:right;bottom:14px;">
                <i v-hasPermi="['enterpr:factory:add']" @click="openDialog()" style="background:#C7C7C7;cursor:pointer;color:#fff;width:32px;height:32px;text-align:center;margin-top:18px;padding-top:7px;border-radius:3px" class="el-icon-plus"></i>
            </span>
        </el-form>
        <!-- 表格 -->
        <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" class="custom-table-header">
            <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
            <el-table-column v-if="false" prop="id" label="id" align="center"></el-table-column>
            <el-table-column prop="factoryName" label="工厂名称" width="200" align="center"></el-table-column>
            <el-table-column prop="factoryAddress" label="工厂地址" align="center"></el-table-column>
            <el-table-column v-if="false" prop="longitude" label="经度" align="center"></el-table-column>
            <el-table-column v-if="false" prop="latitude" label="纬度" align="center"></el-table-column>
            <el-table-column prop="updateByName" label="修改人" align="center"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" align="center"></el-table-column>
            <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <el-button v-hasPermi="['enterpr:workshop:add']" style="color:#3083FB  !important;" @click="handleWorkspace(scope.$index,scope.row)" type="text" size="small">增加车间</el-button>
                    <el-button v-hasPermi="['enterpr:factory:edit']" style="color:#3083FB  !important;" @click="handleEdit(scope.$index,scope.row)" type="text" size="small">修改</el-button>
                    <el-button v-hasPermi="['enterpr:factory:remove']" style="color:#3083FB   !important;" @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <!-- 添加 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="690px" center :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="dialogForm" :rules="rules" label-width="80px" style="padding:0;" :inline="true">
                <!-- <el-row>
                    <el-col :span="10"> -->
                        <el-form-item label="工厂名称" prop="factoryName">
                            <el-input v-model="dialogForm.factoryName" clearable></el-input>
                        </el-form-item>
                    <!-- </el-col>
                    <el-col :span="14"> -->
                        <el-form-item label="工厂地址" prop="factoryAddress">
                            <el-input placeholder="请输入内容" v-model="dialogForm.factoryAddress" clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" class="el-icon-location" @click="addEvent"></el-button>
                        </el-form-item>
                        <el-form-item prop="longitude">
                            <el-input v-model="dialogForm.longitude" style="display:none;"></el-input>
                        </el-form-item>
                        <el-form-item prop="latitude">
                            <el-input v-model="dialogForm.latitude" style="display:none;"></el-input>
                        </el-form-item>
                    <!-- </el-col>
                </el-row> -->
            </el-form>
            
            <div id="map-container" style="width:650px;height:300px;"></div>
            <el-input id="keyworkInp" v-model="keyword" placeholder="输入搜索关键词" clearable style="width:200px;position:absolute;top:117px;left:29px;"></el-input>
            <!-- <div style="z-index:99999">
                <el-input type="text" id="keyworkInp" v-model="keyword" placeholder="输入搜索关键词" /> -->
                <!-- <ul>
                    <li v-for="(item, index) in suggestions" :key="index" @click="selectSuggestion(item)">
                        {{ item.value }}
                    </li>
                </ul> -->
            <!-- </div> -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" style="color:#000 !important;">取 消</el-button>
                <el-button type="primary" @click="handleAdd('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Message, MessageBox} from 'element-ui'
export default {
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                factoryName:""
            },
            dialogForm:{
                factoryName:"",
                factoryAddress:"",
                longitude:116.473008,
                latitude:39.916605
            },
            total:0,
            tableHeight:300,
            // 表格数据
            tableData:[],
            dialogFormVisible:false,//是否显示添加对话框
            dialogTitle:"",
            keyword:'',
            // suggestions:[],
            autoComplete: null,
            map:null,
            marker:null,
            rules:{
                factoryName:[{ required: true, message: '工厂名称不能为空', trigger: 'blur' }],
                factoryAddress:[{ required: true, message: '工厂地址不能为空', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.getList();
    },
    methods: {
        // 获取场景信息列表
        getList(){
            this.$store.dispatch("factory/getFactoryList",this.queryParams).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                }
                else{
                    this.tableData = [];
                    this.total = 0;
                }
            });
        },
        initialize(){
            // 初始化地图
            this.map = new BMap.Map("map-container");
            this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 15); // 默认北京坐标
            // 初始化地图，设置中心点坐标和地图级别  
            this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放

            this.autoComplete = new BMap.Autocomplete({
                input: 'keyworkInp', // 使用 Vue 的 $el 来获取 input 元素
                location: this.map
            });
            this.autoComplete.addEventListener('onconfirm', e => {
                let _value = e.item.value;
                let address = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                // if(this.dialogForm.factoryAddress==""){
                    this.dialogForm.factoryAddress = address;
                // }
                
                // this.suggestions = []; // 清空建议列表，因为已经选择了一个建议项
                // 创建地理编码实例      
                var myGeo = new BMap.Geocoder();  
                myGeo.getPoint(address,(point)=> {
                    this.map.centerAndZoom(point,15); //设置地图中心点
                    if(this.marker){
                        this.map.removeOverlay(this.marker);
                        this.marker = null
                    }
                    this.addPoint({point:{lng:point.lng,lat:point.lat}});
                },this.map)
            });
        },
        // 添加地图点击事件
        addEvent(){ 
            this.map.addEventListener("click", this.addPoint);
        },
        // 地图上加点
        addPoint(e){
            if(!this.marker){
                this.dialogForm.longitude = e.point.lng;
                this.dialogForm.latitude = e.point.lat;
                var point = new BMap.Point(e.point.lng, e.point.lat);
                this.marker = new BMap.Marker(point);  // 创建标注
                this.marker.enableDragging();
                // 拖拽点结束回调函数
                this.marker.addEventListener("dragend", (ev)=>{
                    this.dialogForm.longitude = ev.point.lng;
                    this.dialogForm.latitude = ev.point.lat;
                    // 创建地理编码实例      
                    var myGeo = new BMap.Geocoder();  
                    // 根据坐标得到地址描述    
                    myGeo.getLocation(new BMap.Point(ev.point.lng, ev.point.lat), (result)=>{      
                        if(result){      
                            this.dialogForm.factoryAddress = result.address;
                        }     
                    });
                });

                this.map.addOverlay(this.marker);//将标注添加到地图中   
                this.map.removeEventListener("click", this.addPoint);
                // if(this.dialogForm.factoryAddress == ""){
                    // 创建地理编码实例      
                    var myGeo = new BMap.Geocoder();      
                    // 根据坐标得到地址描述    
                    myGeo.getLocation(point, (result)=>{      
                        if(result){      
                            this.dialogForm.factoryAddress = result.address;
                        }  
                    });
                // }
            }
        },
        // 表单重置
        reset(){
            this.dialogForm = {
                factoryName:"",
                factoryAddress:"",
                longitude:116.473008,
                latitude:39.916605
            };
            if(this.marker){
                this.map.removeOverlay(this.marker); 
                this.marker = null;
            }
        },
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH;//表单的高度会变化
            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
           this.queryParams = {
                pageNum:1,
                pageSize: 10,
                factoryName:""
            }
            this.getList();
        },
        // 行增加车间
        handleWorkspace(index,row){
            let hostUrl = window.location.origin;
            let pageUrl = `${hostUrl}/#/scene-mgmt/workshop-info?id=${row.id}`;
            window.location.href = pageUrl;
            // 处理页签
            this.$store.commit('app/mutationSelectTabs', {path:"/scene-mgmt/workshop-info",name:"/scene-mgmt/workshop-info",title:"车间信息管理"});
        },
        // 行修改
        handleEdit(index,row) {
            this.dialogFormVisible = true;
            this.dialogTitle="工厂信息修改";
            this.reset();
            setTimeout(()=>{
                this.initialize();
                this.map.centerAndZoom(new BMap.Point(row.longitude, row.latitude), 15); //设置地图中心点
                this.addPoint({point:{lng:row.longitude,lat:row.latitude}});
            });
            
            this.$store.dispatch('factory/getFactory',{id:row.id}).then((result)=>{
                if(result){
                    this.dialogForm = result.data;
                }
            });
            // this.dialogForm = row;
        },
        // 行删除
        handleDelete(row) {
            const factoryids = row?.id;
            const factoryNames = row?.factoryName;
            MessageBox.confirm('是否确认删除工厂“' + factoryNames + '”的数据', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('factory/deleteFactory',{ids:factoryids}).then((result)=>{
                    if(result){
                        this.getList();
                        Message.success('删除成功');
                    }
                }); 
            }).catch(() => {          
            });
        },
        // 添加按钮
        openDialog(){
            this.dialogFormVisible = true;
            this.dialogTitle="工厂信息添加";
            this.reset();
            setTimeout(()=>{
                this.initialize();
            });
        },
        // 确认添加
        handleAdd(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.marker){
                        this.map.removeOverlay(this.marker); 
                        this.marker = null;
                    }
                    if(this.dialogForm.id){//修改
                        this.$store.dispatch("factory/editFactory",this.dialogForm).then(()=>{
                            this.getList();
                        });
                    }
                    else{//新增
                        this.$store.dispatch("factory/addFactory",this.dialogForm).then(()=>{
                            this.getList();
                        });
                    }
                    this.dialogFormVisible = false;
                } else {
                    return false;
                }
            });
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    ::v-deep .el-dialog{
        border-radius: 5px;
    }
    ::v-deep .el-dialog__header {
        padding: 6px 19px;
        background: #B1CEF9;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }   
    ::v-deep .el-dialog__headerbtn {
        font-size: 18px;
    }
    ::v-deep .el-dialog__headerbtn {
        top: 10px;
        right: 6px;
    }
    ::v-deep .el-dialog__body {
        padding: 15px 20px;
        border-bottom: 1px solid #D5D5D5;
    }
    // .el-button{
    //     font-size: 12px;
    // }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-dialog__footer {
        padding: 20px;
    }
    ::v-deep .el-table__body-wrapper{
        height: 100%;
        overflow-y: auto;
    }
</style>